import areas from './areas';
import invites from './invites';
import create from './create';
import leave from './leave';
import remove from './remove';
import switchArea from './switch';
import updateInfo from './updateInfo';
import view from './view';

export default {
	// namespaced: true,
	modules: {
		areas, invites, create, leave, switchArea, remove, updateInfo, view
	}
}
